import { useRef } from 'react';

/**
 * id配列を、要素の集合(順序を問わない)が変化しない限り同じ参照を返すようにする。
 *
 * RTDBの購読などで、着目している範囲とは無関係な変更によって配列が再生成されてしまう場合に、
 * それを検知して不要な useEffect の再実行を避けるために使う。
 */
export const useStableIds = <T extends string>(ids: T[]): T[] => {
  const ref = useRef<T[]>(ids);
  const sorted = [...ids].sort();
  const prevSorted = [...ref.current].sort();
  const changed = sorted.length !== prevSorted.length || sorted.some((id, index) => id !== prevSorted[index]);

  if (changed) {
    ref.current = ids;
  }

  return ref.current;
};
